import Cookies from 'js-cookie';
import { isBuildIn } from './build-in';

export const LanguageKey = 'next_lng';

export enum Language {
  en = 'en',
  zhHans = 'zh-Hans',
  zhHant = 'zh-Hant',
  ja = 'ja',
  ko = 'ko',
  fr = 'fr',
  de = 'de',
  es = 'es',
  ru = 'ru',
}

export const getCurrentLanguage = () => {
  const cookieLanguage = Cookies.get(LanguageKey)?.trim();
  const candidate = cookieLanguage || getBrowserPreferredLanguage();
  return adaptLanguage(candidate);
};

const getBrowserPreferredLanguage = () => {
  try {
    if (typeof navigator === 'undefined') return '';
    const languages = Array.isArray(navigator.languages) ? navigator.languages : [];
    return String(languages[0] || navigator.language || '').trim();
  } catch {
    return '';
  }
};

export const adaptLanguage = (lng: string): Language => {
  const lowLng = lng.trim().toLocaleLowerCase();
  const defaultLanguage = isBuildIn() ? Language.en : Language.zhHans;

  if (!lowLng || lowLng === 'undefined' || lowLng === 'null') {
    return defaultLanguage;
  }

  const tw = ['zh-TW', 'zh-HK', 'zh-MO', 'zh-TW', 'zh-CHT', 'zh-Hant', 'tc'].map((i) =>
    i.toLocaleLowerCase()
  );

  if (tw.includes(lowLng) || lowLng.includes('hant')) {
    return Language.zhHant;
  }

  const zh = ['zh-Hans', 'hans', 'zh-CN', 'zh'].map((i) => i.toLocaleLowerCase());
  if (zh.includes(lowLng) || lowLng.includes('hans') || lowLng.startsWith('zh-')) {
    return Language.zhHans;
  }

  const ru = ['ru-RU', 'ru'].map((i) => i.toLocaleLowerCase());
  if (ru.includes(lowLng) || lowLng.startsWith('ru')) {
    return Language.ru;
  }

  const es = ['es-ES', 'es', 'es-MX', 'es-AR', 'es-CO', 'es-CL'].map((i) => i.toLocaleLowerCase());
  if (es.includes(lowLng) || lowLng.startsWith('es')) {
    return Language.es;
  }

  if (lowLng === 'en' || lowLng.startsWith('en-')) return Language.en;
  if (lowLng === 'ja' || lowLng.startsWith('ja-')) return Language.ja;
  if (lowLng === 'de' || lowLng.startsWith('de-')) return Language.de;

  return defaultLanguage;
};
